<template>
  <div class="register-form">
    <b-form @submit.prevent="onSubmit">
      <NanInput
        v-model="form.name"
        :validation="$v.form.name"
        prependIcon="icon-user"
        placeholder="Username"
        aria-label="username"
        class="mb-3"
      />

      <NanInput
        v-model="form.email"
        :validation="$v.form.email"
        type="email"
        prependIcon="icon-envelope"
        placeholder="Email"
        aria-label="email"
        autocomplete="email"
        class="mb-3"
      />

      <NanInput
        v-model="form.pass"
        :validation="$v.form.pass"
        type="password"
        prependIcon="icon-lock"
        placeholder="Password"
        aria-label="password"
        class="mb-3"
      />

      <NanInput
        v-model="repeat"
        :validation="$v.repeat"
        type="password"
        prependIcon="icon-lock"
        placeholder="Repeat Password"
        aria-label="repeat password"
        class="mb-3"
      />

      <NanInput
        v-model="form.customer_type"
        :validation="$v.form.customer_type"
        :options="customer_types"
        prependIcon="icon-user"
        aria-label="I am a part of a"
        type="select"
        class="mb-3"
      />

      <NanInput
        v-model="form.company"
        prependIcon="icon-organization"
        placeholder="Company / Institution (optional)"
        aria-label="company or institution"
        class="mb-3"
      />

      <NanInput
        v-model="form.newsletter"
        type="checkbox"
        label="Notify me of product updates and news"
        class="mb-3"
      />

      <NanInput
        v-model="hasAgreed"
        :validation="$v.hasAgreed"
        type="checkbox"
        required
        class="mb-3"
      >
        <template #label>
          I agree to the
          <a
            id="login-sign_up-terms_of_service"
            href="https://nanome.ai/terms/"
            target="_blank"
            >Terms of Service & Privacy Policy</a
          >
        </template>
      </NanInput>

      <b-button
        id="register-submit-register"
        :class="{ disabled: $v.$invalid }"
        variant="primary"
        block
        type="submit"
        >Register</b-button
      >
    </b-form>
    <OAuthButtons idPrefix="register" />
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  email,
  maxLength,
  minLength,
  required,
  sameAs
} from "vuelidate/lib/validators";
import { password } from "@/helpers/validators";

import OAuthButtons from "@/components/OAuthButtons";

export default {
  components: {
    OAuthButtons
  },

  mixins: [validationMixin],

  data: () => ({
    form: {
      name: "",
      email: "",
      pass: "",
      customer_type: "",
      company: "",
      newsletter: false
    },
    customer_types: [
      { label: "I am a part of a...", value: "", disabled: true },
      { label: "Classroom", value: "classroom" },
      { label: "Academic Lab", value: "academic-lab" },
      { label: "National Research Lab", value: "research-lab" },
      { label: "Commercial Company", value: "commercial" },
      { label: "Other", value: "other" }
    ],
    repeat: "",
    hasAgreed: false
  }),

  created() {
    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
  },

  methods: {
    async onSubmit() {
      this.error = null;

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      await this.$store.dispatch("user/register", this.form);
    }
  },

  validations: {
    form: {
      name: { required, minLength: minLength(6), maxLength: maxLength(250) },
      email: { required, email },
      pass: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(250),
        password
      },
      customer_type: { required }
    },
    repeat: { required, matches: sameAs(v => v.form.pass) },
    hasAgreed: { isTrue: v => v }
  }
};
</script>
